import { GET_PRESS_RELEASE } from '../constants/actionTypes';

export const initialState = {
  pressReleases: []
};

export default (state = initialState, action) => {
  // Action payload
  const { type, payload } = action;

  switch (type) {
    default:
      return state;

    case GET_PRESS_RELEASE:
      return {
        ...state,
        pressReleases: payload
      };
  }
};
